export default function () {
  const byDisplayExample = (a, b) => {
    const sa = a.display_example == null || a.display_example === '' ? null : Number(a.display_example)
    const sb = b.display_example == null || b.display_example === '' ? null : Number(b.display_example)
    const na = Number.isFinite(sa) ? sa : null
    const nb = Number.isFinite(sb) ? sb : null
    if (na == null && nb == null) {
      return (a.id ?? 0) - (b.id ?? 0)
    }
    if (na == null) return 1
    if (nb == null) return -1
    return na - nb || (a.id ?? 0) - (b.id ?? 0)
  }

  const groupingAccesories = function(products) {
    const ordered = [...products].sort(byDisplayExample)
    const groupByProduct = groupArrayOfObjects(ordered, 'product_id')
    const accessories = []

    Object.entries(groupByProduct).forEach(([, rows]) => {
      const sorted = [...rows].sort(byDisplayExample)
      accessories.push({
        title: sorted[0]?.titleRu || '',
        package: sorted[0]?.packageGroup || sorted[0]?.package || '',
        rows: sorted,
      })
    })

    return accessories
  };

  const groupingProducts = function(products, isTablet) {
    const byFeatureName = (a, b) => String(a || '').localeCompare(String(b || ''), 'ru', { sensitivity: 'base' })
    const ordered = [...products].sort(byDisplayExample)
    const groupByPackage = groupArrayOfObjects(ordered, 'package')
    const packages = []

    Object.entries(groupByPackage).forEach(([name, rows]) => {
      const productIds = new Set(rows.map((row) => row.product_id).filter(Boolean))
      packages.push({
        package: name,
        rows,
        productCount: productIds.size || rows.length,
      })
    })

    packages.sort((a, b) =>
      b.productCount - a.productCount
      || String(a.package || '').localeCompare(String(b.package || ''), 'ru', { sensitivity: 'base' })
    )

    const result = []
    packages.forEach((item) => {
      const groupByCategory = groupArrayOfObjects(item.rows, 'category')
      const featureBlocks = Object.entries(groupByCategory)
        .map(([category, rows]) => ({
          package: item.package,
          category,
          rows: [...rows].sort(byDisplayExample),
        }))
        .sort((a, b) => byFeatureName(a.category, b.category))

      result.push(...featureBlocks)
    })

    if (!isTablet) return buildCatalog(result)
    return buildTabletCatalog(result)
  }

  const groupingNewestProducts = function(products, isTablet) {
    const ordered = [...products].sort(byDisplayExample)
    let groupByPackage = groupArrayOfObjects(ordered, 'package')
    let packages = []

    Object.entries(groupByPackage).forEach(item => {
        let categories = []
        item[1].forEach(el => {
            if (categories.indexOf(el.category) === -1) {
                categories.push(el.category);
            }
        });

        categories = categories.join( ' | ' )

      packages.push({
        package: item[0],
        rows: [...item[1]].sort(byDisplayExample),
        category: categories,
        content: item[1][0] && item[1][0].content ? item[1][0].content : '',
        sort_order: Math.max(...item[1].map((el) => el.sort_order ?? 0)),
      })
    })

    packages.sort((a, b) => (b.sort_order ?? 0) - (a.sort_order ?? 0))

    if (!isTablet) return buildCatalog(packages, false)
    return buildTabletCatalog(packages, false)
  }
  
  const buildTabletCatalog = function(products, allowLarge = true) {
    products.forEach(block => {
      block['leftColumn'] = []

      for (let i = 0; i < block.rows.length; i += 3) {
        const row = block.rows.slice(i, i + 3)

        for (let j = 0; j < row.length; j++) row[j]['large'] = false

        if (allowLarge) {
          if (block['leftColumn'].length % 2 === 0) row[0]['large'] = true
          else row[ row.length - 1 ]['large'] = true
        }

        block['leftColumn'].push(row)
      }
    })

    return products
  }

  const buildCatalog = function(products, allowLarge = true) {
    products.forEach(block => {
      const rows = [...block.rows]
      const leftColumn = []
      const rightColumn = []
      const evenLength = rows.length % 2 === 0

      if (allowLarge && rows.length > 4) {
        let bigBlocks = Math.trunc(rows.length / 3)
        let leftBB = evenLength ? bigBlocks / 2 : Math.trunc(bigBlocks / 2)
        let rightBB = bigBlocks - leftBB

        const totalBlocks = rows.length - bigBlocks + (leftBB * 4) + (rightBB * 4)
        const productCount_L = (totalBlocks / 2) - leftBB * 4 + leftBB
        const productCount_R = (totalBlocks / 2) - rightBB * 4 + rightBB

        let delay = 0
        for (let i = 0; i < rows.length; i++) {
          if (i < productCount_L) {
            if (leftBB === productCount_L) {
              rows[i].large = true
            } else if (leftBB > 0 && delay === 0) {
              rows[i].large = true
              leftBB -= 1
              delay = 2
            } else {
              rows[i].large = false
              delay -= 1
            }
            leftColumn.push(rows[i])
            if (i + 1 >= productCount_L) delay = 0
          } else {
            if (rightBB === productCount_R) {
              rows[i].large = true
            } else if (rightBB > 0 && delay === 0) {
              rows[i].large = true
              rightBB -= 1
              delay = 2
            } else {
              rows[i].large = false
              delay -= 1
            }
            rightColumn.push(rows[i])
          }
        }
      } else {
        for (let i = 0; i < rows.length; i++) {
          rows[i].large = false
        }
        if (rows.length <= 2) {
          leftColumn.push(...rows)
        } else {
          const mid = Math.ceil(rows.length / 2)
          leftColumn.push(...rows.slice(0, mid))
          rightColumn.push(...rows.slice(mid))
        }
      }

      block.leftColumn = leftColumn
      block.rightColumn = rightColumn
    })

    return products
  };
  
  const groupArrayOfObjects = function(list, key) {
    return list.reduce(function(rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };

  return {groupingAccesories, groupingProducts, groupingNewestProducts}
}